export const ZAWODY_PAYEE_ID = '1300ac2c-716b-4b20-bc07-047f5e941a16';
export const ZAWODY_CATALOG_ID = '8c687f24-9212-4e0a-94e5-2f49337f9a87';
